import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmStorageManagementRoute: InvariantJiraRoute = {
	name: 'products-jsm-storage-management',
	path: '/jira/settings/products/jira-service-management-storage-management',
	exact: true,
};
